// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav--PCkzM{z-index:2;display:flex;flex-direction:column;gap:.5em;padding:.5em;padding-top:1em}", "",{"version":3,"sources":["webpack://./src/gui/SmartComponents/Proposal/Navigation/index.module.scss"],"names":[],"mappings":"AAAA,YAAK,SAAS,CAAC,YAAY,CAAC,qBAAqB,CAAC,QAAQ,CAAC,YAAY,CAAC,eAAe","sourcesContent":[".nav{z-index:2;display:flex;flex-direction:column;gap:.5em;padding:.5em;padding-top:1em}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": "nav--PCkzM"
};
export default ___CSS_LOADER_EXPORT___;
